import { IOffer, TOfferList } from 'entities/Offer';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings/enums/apiTags.enum';

export const offersApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getOfferList: builder.query<TOfferList, string>({
				query: (params) => ({
					url: `offers/my/${params ? '?' : ''}${params}`,
				}),
			}),
			getAllOfferList: builder.query<TOfferList, string>({
				query: (params) => ({
					url: `meta/offers/${params ? '?' : ''}${params}`,
				}),
			}),
			getOffer: builder.query<IOffer, string>({
				query: (uuid) => ({
					url: `offers/${uuid}/`,
				}),
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.OFFERS_LIST, EApiTags.SINGLE_OFFER],
		endpoints: {
			getOfferList: {
				providesTags: [EApiTags.OFFERS_LIST],
			},
			getOffer: {
				providesTags: [EApiTags.SINGLE_OFFER],
			},
		},
	});

export const { useGetOfferListQuery, useGetOfferQuery, useGetAllOfferListQuery } = offersApi;
